import { itx } from "../translationItx/itx";
import type Consumer from "../models/Consumer";
import BaseDialog from "./BaseDialog";
import type Signal from "../models/Signal";
import type Channel from "../models/Channel";
import type Device from "../models/Device";
import BaseModel from "../models/BaseModel";
import GroupAddress from "../models/GroupAdress";
import ObjectReference from "../components/ObjectReference";

export default function GroupAdressResultDialog(props: {
  groupAddressGenerationInfos: any;
  signalsWithToMuchGroupAddresses: Array<Signal>;
  consumerWithoutActorChannels: Array<Consumer>;
  tempCurrentSignalWithoutButton: Array<Signal>;
  tempCurrentSignalWithToMuchButton: Array<Signal>;
}) {
  const {
    groupAddressGenerationInfos,
    signalsWithToMuchGroupAddresses,
    consumerWithoutActorChannels,
    tempCurrentSignalWithoutButton,
    tempCurrentSignalWithToMuchButton,
  } = props;
  const unChanged =
    groupAddressGenerationInfos.deletedGroupAddressReferenceCount == 0 &&
    groupAddressGenerationInfos.newGroupAddressReferenceCount == 0 &&
    groupAddressGenerationInfos.deletedGroupAddressCount == 0 &&
    groupAddressGenerationInfos.createdGroupAddressCount == 0;

  let signalsWithToMuchGroupAddressesElms: any | undefined;
  let tempCurrentGaWithoutButtonElms: any | undefined;
  const consumerWithoutActorChannelMap = new Map<string, Array<BaseModel>>();

  function ShowErrorElement(props: { errorText: string; errorObjects: Array<BaseModel> }) {
    const { errorText, errorObjects } = props;
    let allObjectsElms = new Array<any>();
    if (errorObjects.length == 0) {
      return null;
    }
    errorObjects.forEach((obj) => {
      allObjectsElms.push(
        <tr
          style={{ cursor: "pointer" }}
          onClick={() => {
            state.selectionManager.selectedObject = obj;
          }}
        >
          <td>{obj.name}</td>
          <ObjectReference obj={obj} showName={false} useSimpleFulltag={true} useAllwaysMaxSpace={false} />
        </tr>,
      );
    });
    return (
      <div>
        {errorText}
        <br />
        <table>
          <tbody>{allObjectsElms}</tbody>
        </table>
        <br />
      </div>
    );
  }

  consumerWithoutActorChannelMap.set("noActorChannelConnection", consumerWithoutActorChannels); // no itx

  if (signalsWithToMuchGroupAddresses.length > 0) {
    signalsWithToMuchGroupAddressesElms = [];

    signalsWithToMuchGroupAddresses.forEach((signal) => {
      const channel = signal.parent as Channel;
      const device = channel?.parent as Device;

      signalsWithToMuchGroupAddressesElms.push(
        <tr
          style={{ cursor: "pointer" }}
          onClick={() => {
            state.selectionManager.selectedObject = channel;
          }}
        >
          <td>
            <i className="las la-external-link-alt" /> &nbsp; {device?.fullTag}
          </td>
          <td>{channel?.shortName} </td>
          <td>{signal.number}</td>
          <td>{signal.knxFunctionText}</td>
        </tr>,
      );
    });
  }

  return (
    <BaseDialog
      hideXButton
      title={itx("adressGenerator.groupAdressesGenerated", "Gruppenadressen wurden aktualisiert")}
      abortCaption={state.translate("close", "Schließen")}
      noOkButton={true}
      onOk={() => {
        return true;
      }}
    >
      {signalsWithToMuchGroupAddressesElms && (
        <div>
          {itx("adressGenerator.toMuchGroupAdressesText", "Folgende Signale haben mehr als 4 Gruppenadressen:")}
          <br />
          <table>
            <tbody>{signalsWithToMuchGroupAddressesElms}</tbody>
          </table>
          <br />
        </div>
      )}
      <ShowErrorElement
        errorText={itx(
          "GroupAdressResultDialog.tempCurrentSignalWithToMuchButton",
          "T1 Signale haben mehrere Ist-Temperatur Button-Verwendungen :",
          { T1: tempCurrentSignalWithToMuchButton.length },
        )}
        errorObjects={tempCurrentSignalWithToMuchButton}
      />
      <ShowErrorElement
        errorText={itx(
          "GroupAdressResultDialog.tempCurrentGaWithoutButton",
          "T1 Signale haben keine Ist-Temperatur Button-Verwendung:",
          { T1: tempCurrentSignalWithoutButton.length },
        )}
        errorObjects={tempCurrentSignalWithoutButton}
      />

      {unChanged && (
        <div>{itx("adressGenerator.noChanges", "Keine Änderungen an den Gruppenadressen und deren Verwendung")}</div>
      )}
      {!unChanged && (
        <table style={{ textAlign: "left" }}>
          <tbody>
            <tr>
              <td>{itx("adressGenerator.deletedGroupAdresses", "Gelöschte Grupenadressen:")}</td>
              <td>{groupAddressGenerationInfos.deletedGroupAddressCount}</td>
            </tr>

            <tr>
              <td>{itx("adressGenerator.generetadGroupAdresses", "Neu erzeuge Grupenadressen:")}</td>
              <td>{groupAddressGenerationInfos.createdGroupAddressCount}</td>
            </tr>

            <tr>
              <td>{itx("adressGenerator.omittedUseOfGroupAdresses", "Entfallene Vewendungen von Grupenadressen:")}</td>
              <td>{groupAddressGenerationInfos.deletedGroupAddressReferenceCount}</td>
            </tr>

            <tr>
              <td>{itx("adressGenerator.newUsageOfGroupAdresses", "Neue Verwendungen von Grupenadressen:")}</td>
              <td>{groupAddressGenerationInfos.newGroupAddressReferenceCount}</td>
            </tr>
          </tbody>
        </table>
      )}
      {/* {consumerWithoutActorChannels.length > 0 && (
        <ShowErrorsToUsersOutsideOfDevelopmentElement groupedErrors={consumerWithoutActorChannelMap} />
      )} */}
    </BaseDialog>
  );
}
